export default __webpack_public_path__ + "static/media/youtube.ceb34084.webp";